import React from 'react';
import PropTypes from 'prop-types';

import {connect} from 'react-redux';
import {IntlProvider} from 'react-intl';

import localeMessages from '../../locales';

const defaultLocale = 'en_US';

// TODO: Drop locale hardcode
@connect(({channels}) => ({
  locale: channels.activeChannel === 'ru' ? 'ru_RU' : (channels.activeLocale || defaultLocale)
}))
export default class IntlProviderContainer extends React.PureComponent {
  static propTypes = {
    children: PropTypes.node
  };

  static extractBaseLocale = localeCode => localeCode.split('_')[0];

  render() {
    const {children, locale} = this.props;

    let baseLocale = IntlProviderContainer.extractBaseLocale(locale);
    if (!localeMessages[baseLocale]) {
      baseLocale = IntlProviderContainer.extractBaseLocale(defaultLocale);
    }

    return (
      <IntlProvider
        key={baseLocale}
        locale={baseLocale}
        messages={localeMessages[baseLocale]}
        children={React.Children.only(children)}
      />
    );
  }
}



// WEBPACK FOOTER //
// ./containers/intl/IntlProviderContainer.js